<template>
  <div class="news">
    <div class="bg-grey">
      <div class="area">
        <div class="row">
          <div class="col-5"></div>
        </div>
      </div>
    </div>
    <BasicTemplate :page-id="3" :showGreyBg="true">
      <NewsList
        v-if="data && list.length > 0"
        :title="data.news.title"
        :list="list"
        :button="data.news.button"
        :haveMore="haveMore"
        @loadmore="fetchMore"
      />
      <template slot="modal">
        <ModalDialogNews :news-id="$route.params.id" ref="modalNews" />
      </template>
    </BasicTemplate>
  </div>
</template>

<script>
import BasicTemplate from "./BasicTemplate.vue";
import NewsList from "../containers/NewsList.vue";
import ModalDialogNews from "../containers/ModalDialogNews.vue";

import utils from "../utils";
import FirstoreUtils from "../firestore-utils";
import { setTimeout } from "timers";
export default {
  name: "News",
  data() {
    return {
      data: undefined,
      list: [],
      utils: utils,
      metaTitle: undefined,
      metaDescription: undefined,
      metaKeywords: undefined,
      metaImage: undefined,
      metaUrl: undefined,
      current: 0,
      countPerPage: 5,
      haveMore: true,
    };
  },
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        { name: "yandex-verification", content: "b7c03678b09c3394" },
        {
          name: "title",
          property: "title",
          content: this.metaTitle,
        },
        {
          name: "description",
          property: "description",
          content: this.metaDescription,
        },
        {
          name: "keywords",
          property: "keywords",
          content: this.metaKeywords,
        },
        {
          name: "og:title",
          property: "og:description",
          content: this.metaTitle,
        },
        {
          name: "og:description",
          property: "og:description",
          content: this.metaDescription,
        },
        {
          name: "og:image",
          property: "og:image",
          content: this.metaImage,
        },
        {
          name: "og:url",
          property: "og:url",
          content: this.metaUrl,
        },
      ],
    };
  },
  watch: {
    $route(to) {
      if (to.params.id) {
        this.showModal();
      } else {
        this.hideModal();
      }
    },
    $refs() {
      if (this.$route.params.id) {
        this.showModal();
      }
    },
  },
  methods: {
    fetchMore() {
      this.fetchNews(
        this.list.length + 1,
        this.list.length + 1 + this.countPerPage
      );
    },
    showModal() {
      console.log(this.$refs, this.$refs.modalNews);
      if (this.$refs && this.$refs.modalNews) {
        this.$refs.modalNews.show();
      }
    },
    hideModal() {
      if (this.$refs && this.$refs.modalNews) {
        this.$refs.modalNews.hide();
      }
    },
    fetchNews() {
      FirstoreUtils.fetchWithFilter(
        "newslist",
        {
          field: "id",
          condition: "<=",
          value: 100000,
        },
        this.countPerPage,
        this.last,
        "id",
        "desc"
      ).then(result => {
        this.last = result.last;
        result.data.forEach(element => {
          element.desc = element.desc.slice(0, 250) + "...";
          element.date = this.utils.parseDateFormat(element.date);
        });
        this.haveMore = result.data.length === this.countPerPage;
        this.list = [...this.list, ...result.data];
      });
    },
  },
  mounted() {
    FirstoreUtils.fetchData("news").then(data => {
      this.data = data;
      this.metaUrl = window.location.href;
      this.metaImage = data.meta.img.src;
      this.metaTitle = data.meta.title;
      this.metaDescription = data.meta.description;
      this.metaKeywords = data.meta.keywords;
      setTimeout(() => {
        document.dispatchEvent(new Event("x-app-rendered"));
      }, 5000);
      console.log(this.$route.params.id);
      setTimeout(() => {
        if (this.$route.params.id) {
          this.showModal();
        } else {
          this.hideModal();
        }
      }, 20);
    });
    this.fetchMore();
  },
  components: {
    BasicTemplate,
    NewsList,
    ModalDialogNews,
  },
};
</script>

<style lang="scss">
.news {
  .app-container {
    background: transparent;
  }
}
</style>
